export default __webpack_public_path__ + "static/media/ChangeTextEnabledPhone.64125a67.png";